/** Declare that this page consumes the console-wide tenant scope.
 *
 * The AppBar chip dims on pages where the scope has no effect. Rather than
 * maintaining a list of scope-aware routes (which would drift the first time a
 * grid is added), every scope-consuming hook registers itself while mounted and
 * the chip reads the live count. This is also automatically right for a page
 * that only shows a tenant-aware grid on one of its tabs.
 *
 * `capability` says what the consumer can take: `'single'` (it adopts the scope
 * only when it names exactly one operator) or `'multi'` (it takes the list). A
 * page with only single consumers dims the chip while the scope names several.
 */
import { useEffect } from 'react';

import { registerScopeConsumer, type ScopeCapability } from './tenantScope';

export function useTenantScopeConsumer(active = true, capability: ScopeCapability = 'single'): void {
  useEffect(() => {
    if (!active) return;
    return registerScopeConsumer(capability);
  }, [active, capability]);
}
